import { isFromPageReload } from './isFromPageReload';
import { isItemPath } from './isItemPath';

// Pathname the document was loaded with. SPA navigations never change it, so
// `path === initialPathname` identifies the URL the user actually opened.
let initialPathname =
  typeof window === 'undefined' ? '' : window.location.pathname;

// Flipped once the app navigates anywhere else. Returning to the initial
// pathname later (list -> row -> same item) is in-app navigation, not a
// cold start.
let leftInitialPathname = false;

// An unauthenticated cold start detours through the login page ('/'), which
// would permanently flip leftInitialPathname. The post-login redirect resumes
// the original cold start, so re-arm the tracking for its target.
export const markPostLoginRedirect = (path: string) => {
  initialPathname = path;
  leftInitialPathname = false;
};

// True only for a cold start straight onto an item/detail URL (external link,
// new tab, pasted URL) — that flow fetches the single record by id.
// Deliberately independent of sessionStorage: a restored tab (reopen closed
// tab, session restore, "continue where you left off") keeps the previous
// life's data, which used to make the cold start look like in-app navigation
// and left the detail resolving the row against filtered data.
export const getIsFromItemExternalUrl = (path: string) => {
  if (path !== initialPathname) {
    leftInitialPathname = true;
    return false;
  }

  if (leftInitialPathname || isFromPageReload()) {
    return false;
  }

  return isItemPath(path);
};
